import React from 'react'
import { graphql } from 'gatsby'
// Material-UI
import { makeStyles } from '@material-ui/styles'
import Container from '@material-ui/core/Container'
// Containers
import Layout from '~2022/containers/Layout'
// Components
import Seo from '~2022/components/Seo'
import { ImageBackgroundDetail } from '~2022/components/ImageBackground'

const useStyles = makeStyles(() => ({
  '@global': {
    html: {
      overflow: 'auto !important',
    },
  },
}))

const Feature = ({ data }) => {
  const { markdownRemark } = data
  const { frontmatter, html } = markdownRemark
  const { title, imageFeatured } = frontmatter
  /**
   * @note[global] This does get called for quick global set for scrolling
   */
  // eslint-disable-next-line no-unused-vars
  const classes = useStyles()
  return (
    <Layout>
      <Seo title={title} />
      <Container maxWidth="sm">
        <div className="entry">
          <ImageBackgroundDetail
            withPageStyles={true}
            imageDetail={imageFeatured}
            imageDetailDesktop={imageFeatured}
            imageDetailMobile={imageFeatured}
            imageDetailPlaceholder={imageFeatured}
            imageDetailTablet={imageFeatured}
          >
            <span> </span>
          </ImageBackgroundDetail>
          <h1 className="entry-title title-effect" data-text={title}>
            {title}
          </h1>
          <div
            className="entry-content"
            dangerouslySetInnerHTML={{ __html: html }}
            style={{ marginTop: '1rem' }}
          />
        </div>
      </Container>
    </Layout>
  )
}

export const pageQuery = graphql`
  query ($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        imageFeatured
      }
    }
  }
`

export default Feature
